export default "__VITE_ASSET__CVvHEvDX__"